// extracted by mini-css-extract-plugin
module.exports = {"cards":"JIjdI","synopsiscard":"CbLpQ","synopsisHglts":"Gy51X","containerImg":"jXlaq"};